import React from "react";
import {
  Attachment3dModel,
  AttachmentImage,
  GallerySlider as GallerySliderUI,
  GallerySliderProps,
} from "@msys/ui";
import { useTranslate } from "@tolgee/react";
import { useDownloadFile } from "../hooks/useDownloadFile.js";

export const GallerySlider = <I extends AttachmentImage | Attachment3dModel>(
  props: GallerySliderProps<I>
) => {
  const { t } = useTranslate("Global");
  const { downloadFileFromUrl, downloading } = useDownloadFile();
  return (
    <GallerySliderUI
      downloadTitle={t("Download")}
      addTitle={t("Add")}
      rotateTitle={t("Rotate")}
      deleteTitle={t("Delete")}
      arButtonTitle={t("View in your space")}
      handleDownloadFileFromUrl={downloadFileFromUrl}
      downloading={downloading}
      {...props}
    />
  );
};
